/* Copper-free theme: cart drawer, quick add, timers, gallery dots */
(() => {
  const root = window.Shopify && Shopify.routes ? Shopify.routes.root : '/';
  const drawer = () => document.getElementById('cs-drawer');

  async function refreshDrawer() {
    const res = await fetch(`${root}?sections=cs-cart-drawer`);
    const html = (await res.json())['cs-cart-drawer'];
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const fresh = doc.getElementById('cs-drawer-inner');
    const cur = document.getElementById('cs-drawer-inner');
    if (fresh && cur) cur.replaceWith(fresh);
    const count = doc.getElementById('cs-drawer-inner')?.dataset.count || '0';
    document.querySelectorAll('.cart-count-bubble span[aria-hidden], [data-cs-count]').forEach((el) => (el.textContent = count));
    startHold();
  }

  function openDrawer() {
    const d = drawer();
    if (!d) return (window.location.href = `${root}cart`);
    d.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }
  function closeDrawer() {
    drawer()?.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  async function addToCart(id, qty = 1, extra = []) {
    const res = await fetch(`${root}cart/add.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: qty }, ...extra.map((x) => ({ id: Number(x), quantity: 1 }))] }),
    });
    if (!res.ok) {
      const err = await res.json().catch(() => ({}));
      alertInline(err.description || 'Ce produit n’est plus disponible.');
      return;
    }
    await refreshDrawer();
    openDrawer();
  }

  async function changeLine(key, qty) {
    await fetch(`${root}cart/change.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty }),
    });
    await refreshDrawer();
  }

  function alertInline(msg) {
    const el = document.querySelector('[data-cs-error]');
    if (el) { el.textContent = msg; el.hidden = false; } else console.warn(msg);
  }

  // reservation timer in the drawer: one window per browser session
  let holdInterval;
  function startHold() {
    const el = document.querySelector('[data-cs-hold]');
    if (!el) return;
    const mins = Number(el.dataset.minutes || 4);
    let end;
    try { end = Number(sessionStorage.getItem('cs-hold-end')); } catch (e) {}
    if (!end || end < Date.now()) {
      end = Date.now() + mins * 60000;
      try { sessionStorage.setItem('cs-hold-end', end); } catch (e) {}
    }
    clearInterval(holdInterval);
    const tick = () => {
      const s = Math.max(0, Math.round((end - Date.now()) / 1000));
      el.textContent = `${Math.floor(s / 60)}:${String(s % 60).padStart(2, '0')}`;
      if (!s) clearInterval(holdInterval);
    };
    tick();
    holdInterval = setInterval(tick, 1000);
  }

  // countdown to local midnight
  function startMidnightTimers() {
    document.querySelectorAll('[data-cs-midnight]').forEach((box) => {
      const h = box.querySelector('[data-h]'), m = box.querySelector('[data-m]'), s = box.querySelector('[data-s]');
      const tick = () => {
        const now = new Date();
        const end = new Date(now); end.setHours(24, 0, 0, 0);
        const left = Math.max(0, Math.floor((end - now) / 1000));
        h.textContent = String(Math.floor(left / 3600)).padStart(2, '0');
        m.textContent = String(Math.floor((left % 3600) / 60)).padStart(2, '0');
        s.textContent = String(left % 60).padStart(2, '0');
      };
      tick();
      setInterval(tick, 1000);
    });
  }

  function initGalleries() {
    document.querySelectorAll('[data-cs-gallery]').forEach((g) => {
      const track = g.querySelector('.cs-scroll');
      const dots = [...g.querySelectorAll('.cs-gallery__dots button')];
      dots.forEach((d, i) => d.addEventListener('click', () => track.scrollTo({ left: i * track.clientWidth, behavior: 'smooth' })));
      track.addEventListener('scroll', () => {
        const i = Math.round(track.scrollLeft / track.clientWidth);
        dots.forEach((d, j) => d.classList.toggle('is-active', i === j));
      }, { passive: true });
    });
  }

  document.addEventListener('click', (e) => {
    const add = e.target.closest('[data-cs-add]');
    if (add) {
      e.preventDefault();
      add.disabled = true;
      addToCart(add.dataset.csAdd).finally(() => (add.disabled = false));
      return;
    }
    const qty = e.target.closest('[data-cs-qty]');
    if (qty) return changeLine(qty.dataset.key, Number(qty.dataset.csQty));
    if (e.target.closest('[data-cs-close]')) return closeDrawer();
  });

  // capture phase: Dawn's own listener on the cart icon would otherwise open its drawer underneath ours
  document.addEventListener('click', (e) => {
    if (e.target.closest('#cart-icon-bubble, [data-cs-open]') && drawer()) {
      e.preventDefault();
      e.stopPropagation();
      refreshDrawer().then(openDrawer);
    }
  }, true);

  // main product form: ATC through the drawer instead of the cart page
  document.addEventListener('submit', (e) => {
    const form = e.target.closest('form[data-cs-form]');
    if (!form) return;
    e.preventDefault();
    const id = new FormData(form).get('id');
    const btn = form.querySelector('[type=submit]');
    if (btn) btn.disabled = true;
    const gift = form.querySelector('[data-cs-gift]:checked');
    addToCart(id, 1, gift ? [gift.value] : []).then(() => { if (gift) gift.checked = false; }).finally(() => btn && (btn.disabled = false));
  });

  document.addEventListener('keydown', (e) => e.key === 'Escape' && closeDrawer());
  document.addEventListener('DOMContentLoaded', () => { startHold(); startMidnightTimers(); initGalleries(); });
  window.csCart = { open: openDrawer, refresh: refreshDrawer, add: addToCart };
})();
